/* Smelody optimisation sprint — Ali Hanif, Oct 2026
   Kept separate from Prestige core files so theme updates don't wipe it. */
(function () {
  'use strict';

  var tracks = function () { return Array.prototype.slice.call(document.querySelectorAll('audio.sm-track')); };
  var anyPlaying = function () { return tracks().some(function (a) { return !a.paused; }); };

  /* Header icon + saved preference follow what is actually playing */
  function syncGlobal() {
    var playing = anyPlaying();
    document.body.classList.toggle('sm-sound-active', playing);
    try { sessionStorage.setItem('sm_sound', playing ? '1' : '0'); } catch (e) {}
  }

  /* 1. One track at a time: when any audio on the page starts, pause all the others
        (homepage ambient, product packshot button, "Écouter la musique" player). */
  /* muted background videos (homepage hero) are ignored: they keep looping and never stop the music */
  var isBgVideo = function (m) { return m.tagName === 'VIDEO' && m.muted; };
  document.addEventListener('play', function (e) {
    if (!(e.target instanceof HTMLMediaElement) || isBgVideo(e.target)) return;
    document.querySelectorAll('audio, video').forEach(function (m) {
      if (m !== e.target && !m.paused && !isBgVideo(m)) m.pause();
    });
    setTimeout(syncGlobal, 0);
  }, true);
  document.addEventListener('pause', function (e) {
    if (e.target instanceof HTMLMediaElement) setTimeout(syncGlobal, 0);
  }, true);

  /* (19 Oct) Visitor's mute choice, remembered for the whole site for the browsing session:
     muted once = no autoplay on any other page until they turn the sound back on */
  var muteKey = 'sm_muted';
  function isPageMuted() { try { return sessionStorage.getItem(muteKey) === '1'; } catch (e) { return false; } }
  function setPageMuted(on) { try { if (on) { sessionStorage.setItem(muteKey, '1'); } else { sessionStorage.removeItem(muteKey); } } catch (e) {} }

  /* 2. Global toggle used by the header button */
  function pageTrack() {
    var pdp = document.querySelector('[data-sm-play]');
    return pdp ? document.getElementById(pdp.dataset.smPlay) : document.getElementById('sm-ambient');
  }
  window.SmelodySound = {
    /* the page's own music: the product's track on a product page, the homepage music elsewhere */
    playPageTrack: function () {
      var t = pageTrack();
      if (t) t.play().catch(function () {});
    },
    toggle: function () {
      if (anyPlaying()) { tracks().forEach(function (a) { a.pause(); }); setPageMuted(true); return; }
      setPageMuted(false);
      this.playPageTrack();
    }
  };

  /* 3. Product page music button: toggle its track; icon + label follow the track's real state */
  function syncButton(btn, playing) {
    var label = btn.querySelector('.pdp-play-label');
    var text = playing ? btn.dataset.labelPause : btn.dataset.labelPlay;
    btn.classList.toggle('playing', playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    btn.setAttribute('aria-label', text);
    if (label) label.textContent = text;
  }

  document.querySelectorAll('[data-sm-play]').forEach(function (btn) {
    var audio = document.getElementById(btn.dataset.smPlay);
    if (!audio) return;
    btn.addEventListener('click', function () {
      if (audio.paused) { setPageMuted(false); audio.play().catch(function () {}); } else { setPageMuted(true); audio.pause(); }
    });
    audio.addEventListener('play', function () { syncButton(btn, true); });
    audio.addEventListener('pause', function () { syncButton(btn, false); });
  });

  /* Music starts by itself on every page (homepage music, or the product's own track on a product page)
     unless the visitor muted it on this page. Browsers block sound before the first interaction, so if the
     direct start is refused, it starts on the first tap / click / key press (except on the sound buttons themselves). */
  (function () {
    if (isPageMuted()) return;
    /* (21 Oct) homepage: the film's own sound starts instead (smelody-video.js); music only from the header button */
    if (document.querySelector('[data-sm-film] video, template[data-sm-video]')) return;
    var track = pageTrack();
    if (!track) return;
    var events = ['pointerdown', 'touchend', 'keydown'];
    var done = false;
    var cleanup = function () { done = true; events.forEach(function (ev) { document.removeEventListener(ev, onGesture, true); }); };
    var start = function () {
      if (done || isPageMuted() || anyPlaying()) { cleanup(); return; }
      var p = track.play();
      if (p && p.then) { p.then(cleanup).catch(function () {}); } else { cleanup(); }
    };
    var onGesture = function (e) {
      if (e.target && e.target.closest && e.target.closest('#sm-sound-btn, [data-sm-play], [data-sm-player], .sm-video-sound')) { cleanup(); return; }
      start();
    };
    events.forEach(function (ev) { document.addEventListener(ev, onGesture, true); });
    start();
  })();

  /* 4. On load, the header icon shows "on" only if something is actually playing
        (the homepage starts its own autoplay attempt earlier, in snippets/smelody-enterance.liquid). */
  if (!anyPlaying()) document.body.classList.remove('sm-sound-active');

  /* 5. Scroll-to-top button on every page (task 5) */
  (function () {
    var lang = (document.documentElement.lang || 'fr').slice(0, 2);
    var labels = { fr: 'Haut de page', en: 'Back to top', de: 'Nach oben' };
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-to-top';
    btn.setAttribute('aria-label', (window.SmelodyI18n && window.SmelodyI18n.backToTop) || labels[lang] || labels.fr);
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 15 12 9 18 15"></polyline></svg>';
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);
    if (document.querySelector('product-sticky-bar')) document.body.classList.add('sm-has-sticky-bar');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.scrollY > window.innerHeight);
        ticking = false;
      });
    }, { passive: true });
  })();

  /* 6. Sticky add-to-cart bar mirrors the main button (task 5): same label, price and gold colour.
        Done here so the core Prestige section stays untouched. */
  (function () {
    var main = document.querySelector('.product-info buy-buttons button[type="submit"]');
    var sticky = document.querySelector('product-sticky-bar buy-buttons button[type="submit"]');
    if (!main || !sticky) return;
    sticky.innerHTML = main.innerHTML;
    var style = main.getAttribute('style');
    if (style) sticky.setAttribute('style', style);
  })();

  /* ============ Batch 3 — product page QA (13 Oct) ============ */

  var isMobile = function () { return window.matchMedia('(max-width: 699px)').matches; };

  /* #1 + #2 sticky bar: scroll-to-top inside the bar on mobile; Perfumist lifts while the bar shows */
  (function () {
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return;
    var floating = document.querySelector('.sm-to-top');
    if (floating) {
      var inbar = floating.cloneNode(true);
      inbar.classList.add('sm-to-top--inbar');
      inbar.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
      bar.insertBefore(inbar, bar.firstChild);
    }
    bar.classList.add('sm-bar-ready');
    /* (19 Oct) mobile: on small screens the add-to-cart button can sit below the first screen;
       show the sticky bar until the real button scrolls into view (the theme takes over once it has been passed) */
    var mainBuy = document.querySelector('.product-info buy-buttons');
    if (mainBuy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = !e.isIntersecting && e.boundingClientRect.top > 0;
        bar.classList.toggle('sm-bar-early', below && isMobile());
        sync();
      }).observe(mainBuy);
    }
    var sync = function () {
      var shown = (bar.classList.contains('is-visible') || bar.classList.contains('sm-bar-early')) && isMobile();
      document.body.classList.toggle('sm-sticky-shown', shown);
      if (shown) document.body.style.setProperty('--sm-bar-h', bar.offsetHeight + 'px');
    };
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync);
    sync();
  })();

  /* Perfumist injects its button after load: find it (fixed position, perfumist id/class or "advisor" text) */
  (function () {
    var tries = 0;
    var find = function () {
      /* (21 Oct speed) look up the widget directly instead of measuring every element on the page */
      var hit = document.getElementById('perfumist-wpa-iframe') || document.querySelector('[id*="perfumist" i]');
      if (hit) { hit.classList.add('sm-perfumist-lift'); if (hit.tagName === 'IFRAME' && !hit.title) hit.title = 'Perfumist'; return; }
      if (++tries < 20) setTimeout(find, 750);
    };
    find();
  })();

  /* #2 floating scroll-to-top hides while the footer is on screen */
  (function () {
    var footer = document.querySelector('.shopify-section--footer, footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('sm-footer-visible', entries[0].isIntersecting);
    }).observe(footer);
  })();

  /* #8 branded player for "Écouter la musique" */
  var fmt = function (s) {
    if (!isFinite(s)) return '--:--';
    s = Math.floor(s);
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  };
  document.querySelectorAll('[data-sm-player]').forEach(function (p) {
    var audio = p.querySelector('audio');
    var btn = p.querySelector('.sm-player__btn');
    var seek = p.querySelector('.sm-player__seek');
    var time = p.querySelector('.sm-player__time');
    if (!audio || !btn || !seek) return;
    var paint = function () {
      var pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      seek.value = pct;
      seek.style.setProperty('--sm-progress', pct + '%');
      if (time) time.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
    };
    btn.addEventListener('click', function () {
      if (audio.paused) { audio.play().catch(function () {}); } else { audio.pause(); }
    });
    seek.addEventListener('input', function () {
      if (audio.duration) audio.currentTime = (seek.value / 100) * audio.duration;
      paint();
    });
    audio.addEventListener('play', function () { p.classList.add('is-playing'); btn.setAttribute('aria-label', btn.dataset.labelPause); });
    audio.addEventListener('pause', function () { p.classList.remove('is-playing'); btn.setAttribute('aria-label', btn.dataset.labelPlay); });
    ['timeupdate', 'loadedmetadata', 'durationchange'].forEach(function (ev) { audio.addEventListener(ev, paint); });
  });

  /* #6 related products on a product page: drop the product you're on, show 4 */
  (function () {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    document.querySelectorAll('[id*="featured_collections_cWAxwA"] .product-list').forEach(function (list) {
      var shown = 0;
      Array.prototype.forEach.call(list.querySelectorAll('product-card'), function (card) {
        if (card.getAttribute('handle') === handle || shown >= 4) { card.remove(); return; }
        shown++;
      });
    });
  })();

  /* #19 "En savoir plus" under the composer opens that composer's section on the composers page */
  var slug = function (t) {
    t = (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    t = t.replace(/^r\.?\s+strauss$/, 'richard strauss');
    return t.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };
  if (/\/pages\/musical-composer/.test(window.location.pathname)) {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      var h = sec.querySelector('h3');
      if (!h || /header|footer/.test(sec.id)) return;
      /* an anchor inside the section: section ids are used by the theme's own styles, so they stay untouched */
      var anchor = document.createElement('span');
      anchor.id = 'sm-composer-' + slug(h.textContent);
      anchor.style.cssText = 'display:block;position:relative;';
      sec.insertBefore(anchor, sec.firstChild);
    });
    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) setTimeout(function () { target.scrollIntoView(); }, 100);
    }
  } else {
    document.querySelectorAll('a[href*="/pages/musical-composer"]').forEach(function (a) {
      var sec = a.closest('.shopify-section');
      var h = sec && sec.querySelector('h3');
      if (h && a.href.indexOf('#') === -1) a.href = a.href + '#sm-composer-' + slug(h.textContent);
    });
  }

  /* (15 Oct) "La Fragrance" text is always shown, at the client's request */

  /* Cards in the same row: composer lines share one height so format line, price and button line up,
     without the old fixed 40px gap under one-line composers. */
  (function () {
    var lists = document.querySelectorAll('.product-list');
    if (!lists.length) return;
    var run = function () {
      lists.forEach(function (list) {
        var music = list.querySelectorAll('.product-card-music');
        music.forEach(function (m) { m.style.minHeight = ''; });
        var rows = {};
        music.forEach(function (m) {
          var top = Math.round(m.closest('product-card').getBoundingClientRect().top);
          (rows[top] = rows[top] || []).push(m);
        });
        /* (15 Oct) title + composer measured together, so a two-line title (coffret) no longer pushes its format line, price and button below the row */
        var titleH = function (m) { var t = m.closest('product-card').querySelector('.product-title'); return t ? t.offsetHeight : 0; };
        Object.keys(rows).forEach(function (k) {
          if (rows[k].length < 2) return;
          var h = Math.max.apply(null, rows[k].map(function (m) { return m.offsetHeight + titleH(m); }));
          rows[k].forEach(function (m) { m.style.minHeight = (h - titleH(m)) + 'px'; });
        });
      });
    };
    run();
    window.addEventListener('load', run);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 150); });
  })();
})();

/* (19 Oct) hero video: if the phone blocked autoplay (e.g. Low Power Mode), start it on the first tap */
(function () {
  var go = function (e) {
    document.querySelectorAll('video-media[autoplay] video').forEach(function (v) {
      if (e && e.target && (e.target === v || (e.target.closest && e.target.closest('video-media') === v.parentNode))) return;
      if (v.paused && !v.dataset.smStarted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  };
  document.addEventListener('playing', function (e) { if (e.target instanceof HTMLVideoElement) e.target.dataset.smStarted = '1'; }, true);
  ['touchend', 'click'].forEach(function (ev) { document.addEventListener(ev, go, { passive: true }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });
})();
